
import router from '../utils/router'
export default async function ({ app, store, redirect, route }) {
  if (process.server) {
    await app.$indexApi.getUserInfo().then(res => {
      if (res.code === 200) {
        store.dispatch("setUserInfo", res.data)
      } else {
        store.dispatch("setUserInfo", {})

        if (route.path !== '/login') {
          return redirect(`${'/login?reload=' + Date.now()}`)
        }
      }
    })
    //用户栏目
     await app.$indexApi.getRouter().then(res =>{
       if (res.code === 200) {
         store.dispatch("setRouters", res.data)
       }else{
         store.dispatch("setRouters", router)
       }
     })
    //store.dispatch("setRouters", router)
  }
}
